<div class="main-container center-shell">
    <div class="content-wrap">
        <div class="upper-section">
            <div class="head-section">
                <h1 class="page-title">Identity Verification</h1>
                <div class="underline"></div>
                <p class="note">
                    As part of onboarding, your employer requires you to verify your identity to ensure compliance and protect sensitive
                    health data. By continuing, you will receive an email from
                    <strong>CERTN</strong>. Open that email and complete the verification to proceed.
                </p>
            </div>
        </div>

        <!-- STATUS BANNERS -->
        <div *ngIf="isPending" class="status-banner info">
            <ion-icon name="information-circle-outline"></ion-icon>
            <span>
                We’ve already sent a CERTN verification email to <b>{{ email?.value }}</b>.
                Please check your inbox and spam folders and complete the verification.
            </span>
        </div>

        <div *ngIf="isApproved" class="status-banner success">
            <ion-icon name="checkmark-circle-outline"></ion-icon>
            <span>Your identity verification has been <b>approved</b>. Thank you!</span>
        </div>

        <div class="main-wrapper">
            <div class="info-card">
                <div class="email-pill">
                    <ion-icon name="mail-outline"></ion-icon>
                    <span>{{ email?.value || '—' }}</span>
                    <ion-icon name="checkmark-circle" class="ok"></ion-icon>
                </div>

                <ul class="bullets">
                    <li>We’ll send a verification request to the email shown above.</li>
                    <li>The request will come from <b>CERTN</b>, our identity-verification partner.</li>
                    <li>Complete that verification to continue using the platform.</li>
                </ul>
            </div>
        </div>
    </div>
</div>

<!-- Sticky CTA aligned to content width -->
<div class="page-cta">
    <div class="cta-inner">
        <!-- Pending -> Go back; Approved -> hide CTA; Else -> Continue -->
        <ion-button *ngIf="isPending" expand="block" class="continue-btn" color="dark" (click)="goBack()">
            Go back
        </ion-button>

        <ion-button *ngIf="!isPending && !isApproved" expand="block" class="continue-btn" color="dark"
            (click)="submit()" [disabled]="isSubmitting">
            Continue
            <ion-spinner name="lines-sharp-small" *ngIf="isSubmitting"></ion-spinner>
        </ion-button>
    </div>
</div>